import { render, staticRenderFns } from "./OrdersDispatchDetail.vue?vue&type=template&id=28dfd600&scoped=true"
import script from "./OrdersDispatchDetail.vue?vue&type=script&lang=ts"
export * from "./OrdersDispatchDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrdersDispatchDetail.vue?vue&type=style&index=0&id=28dfd600&lang=scss"
import style1 from "./OrdersDispatchDetail.vue?vue&type=style&index=1&id=28dfd600&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dfd600",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28dfd600')) {
      api.createRecord('28dfd600', component.options)
    } else {
      api.reload('28dfd600', component.options)
    }
    module.hot.accept("./OrdersDispatchDetail.vue?vue&type=template&id=28dfd600&scoped=true", function () {
      api.rerender('28dfd600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/components/OrdersDispatchDetail.vue"
export default component.exports